<template>
	<div>
		<vxe-modal size="mini" v-model="model" width="1200" height="800" :show-footer="true" destroy-on-close
			@show="show" @hide="hide" transfer :lock-scroll="false" :showHeader="true" :loading="loading" title="智能拆单">
			<template #default>
				<el-form ref="form" :inline="true" :model="form" label-width="80px">
					<el-form-item label="" label-width="0px">
						<el-input placeholder="请输入订单编码" v-model="form.ordercode">
							<el-button @click="autoSplitOrder" slot="append" icon="el-icon-search"></el-button>
						</el-input>
					</el-form-item>
				</el-form>
				<el-divider content-position="center">单据信息</el-divider>
				<vxe-table align="center" size="mini" :data="orderinfo" border style="margin-bottom: 50px;">
					<vxe-column field="salercpt_no" title="单据编码"></vxe-column>
					<vxe-column field="storage_name" title="发货仓库"></vxe-column>
					<vxe-column field="address" title="省市区">
						<template #default="{row}">
							<span>{{row.tp_receiver_state+'/'+row.tp_receiver_city+'/'+row.tp_receiver_district}}</span>
						</template>
					</vxe-column>
					<vxe-column field="controll" title="操作推荐">
						<template #default="{row}">
							<span>{{row.controll.length==0?'无': row.controll.join('/')}}</span>
						</template>
					</vxe-column>
				</vxe-table>
				<el-divider content-position="center">拆单/发货仓推荐</el-divider>
				<template v-for="(item,index) in tableList">
					<vxe-table :key="index+Math.random()" :data="item.order" size="mini" border
						style="margin-bottom: 10px;">
						<vxe-column type="seq" width="60"></vxe-column>
						<vxe-column field="salercpt_no" title="父级单号"></vxe-column>
						<vxe-column field="bar_code" title="商品编码"></vxe-column>
						<vxe-column field="tp_item_size" title="商品数量"></vxe-column>
						<!-- 						<vxe-column field="controll" title="省市区">
							<template #default="{row}">
								<span>{{row.tp_receiver_state+'/'+row.tp_receiver_city+'/'+row.tp_receiver_district}}</span>
							</template>
						</vxe-column> -->
						<vxe-column field="storage_name" title="发货仓库(推荐)"></vxe-column>
						<vxe-column field="availableSize" title="可用库存"></vxe-column>
						<vxe-column field="cityorder" title="城市优先级"></vxe-column>
						<vxe-column field="getday" title="到货时效"></vxe-column>
						<vxe-column field="error" title="备注"></vxe-column>
						<vxe-column field="controll" title="操作推荐">
							<template #default>
								<span>{{fomattercontroll(item.controll)}}</span>
							</template>
						</vxe-column>

					</vxe-table>
				</template>
			</template>
			<template #footer>
				<vxe-button size="mini" status="primary" content="提交任务" @click="submit(false)"></vxe-button>
			</template>


		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				model: true,
				form: {
					ordercode: null
				},
				tableList: [],
				orderinfo: [],
			}
		},
		created() {

		},
		mounted() {



		},
		watch: {

		},
		computed: {

		},

		methods: {
			autoSplitOrder() {
				this.loading = true
				this.$api.goods.autoSplitOrder(this.form.ordercode).then((res) => {
					//console.log(res)
					this.tableList = res.res
					this.tableList.forEach((item) => {
						if (item.controll == 1) {
							res.order.controll.push('改仓')
						}
						if (item.controll == 2) {
							res.order.controll.push('拆单')
						}
					})
					res.order.controll = [...new Set(res.order.controll)]
					this.orderinfo = [res.order]
					console.log(this.orderinfo)
					this.loading = false
				}, () => {
					this.loading = false
				})
			},
			fomattercontroll(controll) {
				if (controll == 0) {
					return '无'
				}
				if (controll == 1) {
					return '无'
				}
				if (controll == 2) {
					return '拆出改仓'
				}
			},
			show() {

			},
			hide() {
				this.$emit('hide')
			},
			submit() {
				console.log(this.tableList)
				this.$api.tool.saveSplitTrade({
					data: this.tableList
				}).then(() => {
					this.$message.success('操作成功')
				})
			}
		},
		components: {

		}
	}
</script>